import React, { useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon } from 'lucide-react';
interface LegalModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}
export function LegalModal({
  isOpen,
  onClose,
  title,
  children
}: LegalModalProps) {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [isOpen]);
  return <AnimatePresence data-id="element-216">
      {isOpen && <div className="fixed inset-0 z-50 flex items-center justify-center p-4" data-id="element-217">
          {/* Backdrop */}
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.2
      }} className="absolute inset-0 bg-charcoal/60 backdrop-blur-sm" onClick={onClose} data-id="element-218" />

          {/* Modal */}
          <motion.div initial={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} exit={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} transition={{
        duration: 0.3,
        ease: 'easeOut'
      }} className="relative bg-warmBg rounded-2xl shadow-2xl w-full max-w-2xl max-h-[85vh] flex flex-col" data-id="element-219">
            {/* Header */}
            <div className="flex items-center justify-between p-6 border-b border-charcoal/10 flex-shrink-0" data-id="element-220">
              <h2 className="text-2xl font-bold text-charcoal font-heading" data-id="element-221">
                {title}
              </h2>
              <button onClick={onClose} className="p-2 rounded-full hover:bg-charcoal/5 transition-colors focus:outline-none focus:ring-2 focus:ring-sage/50" aria-label="Cerrar" data-id="element-222">
                <XIcon className="w-5 h-5 text-charcoal/60" data-id="element-223" />
              </button>
            </div>

            {/* Content */}
            <div className="p-6 overflow-y-auto flex-1 text-charcoal/80 leading-relaxed space-y-4 text-sm" data-id="element-224">
              {children}
            </div>

            {/* Footer */}
            <div className="p-4 border-t border-charcoal/10 flex-shrink-0 text-center" data-id="element-225">
              <button onClick={onClose} className="text-sage font-semibold hover:text-sage/80 transition-colors text-sm" data-id="element-226">
                Cerrar
              </button>
            </div>
          </motion.div>
        </div>}
    </AnimatePresence>;
}